// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconStep_step__IHCWf {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.IconStep_step__IHCWf .IconStep_step-container__vRdId {
  height: 64px;
  width: 64px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0px 8px 8px 0px rgba(153, 153, 153, 0.15);
  border-radius: 32px;
  justify-content: center;
  color: #666666;
  z-index: 2;
}
.IconStep_step__IHCWf .IconStep_step-container__vRdId .IconStep_selected__Zjiep {
  color: #ff6b00;
}

.IconStep_button__ZhoDD {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  border: none;
  border-radius: 80px;
  align-items: center;
  justify-content: center;
  padding: 11px 24px;
  background-color: transparent;
  color: #666666;
  font-size: 12px;
  padding: 0;
}
.IconStep_button__ZhoDD p {
  margin: 0;
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Stepper/IconStep/IconStep.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAFF;AAGE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qDAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCTM;EDUN,UAAA;AADJ;AAEI;EACE,cChBI;ADgBV;;AAIA;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,cCzBQ;ED0BR,eEjCO;EFkCP,UAAA;AADF;AAEE;EACE,SAAA;EACA,cCrCM;ADqCV","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.step {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  .step-container {\n    height: 64px;\n    width: 64px;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 8px 8px 0px rgba(153, 153, 153, 0.15);\n    border-radius: 32px;\n    justify-content: center;\n    color: colors.$default;\n    z-index: 2;\n    .selected {\n      color: colors.$primary;\n    }\n  }\n}\n.button {\n  width: fit-content;\n  display: flex;\n  border: none;\n  border-radius: 80px;\n  align-items: center;\n  justify-content: center;\n  padding: 11px 24px;\n  background-color: transparent;\n  color: colors.$default;\n  font-size: typography.$body-s;\n  padding: 0;\n  p {\n    margin: 0;\n    color: colors.$neutral;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `IconStep_step__IHCWf`,
	"step-container": `IconStep_step-container__vRdId`,
	"selected": `IconStep_selected__Zjiep`,
	"button": `IconStep_button__ZhoDD`
};
export default ___CSS_LOADER_EXPORT___;
